import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RadioIndicator from '../__partials/radio-indicator';
import idGenerator from '../../__utils/idGenerator';

const Radio = ({ label, name, value, id, checked, disabled, onChange, qaId }) => {
  function handleChange() {
    onChange(value);
  }

  let newId = id;

  if (!newId) {
    newId = idGenerator();
  }

  const radioItemClasses = classNames('uni-form__radio-item', {
    'uni-form__radio-item--is-checked': checked,
    'uni-form__radio-item--is-disabled': disabled,
  });

  return (
    <div className={radioItemClasses}>
      <label className="uni-form__label--radio" htmlFor={newId}>
        <RadioIndicator />

        <input
          id={newId}
          className="uni-form__input--radio"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          data-qa-id={qaId}
        />

        {label}
      </label>
    </div>
  );
};

Radio.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  qaId: PropTypes.string,
};

Radio.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => {},
};

export default Radio;



// WEBPACK FOOTER //
// ./src/forms/radio/index.jsx